/**
 * SignatureNudge — one-shot toast that fires when the user has just
 * completed their Industry Architect setup for the first time AND has
 * not yet set up their email signature. Once shown, the backend records
 * it and the toast never appears again (per spec).
 *
 * Renders nothing visually itself — fires a sonner toast from useEffect
 * exactly once when the gate flips true.
 */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useOnboarding } from '../../context/OnboardingContext';

export default function SignatureNudge() {
  const { state, markSignatureNudgeShown } = useOnboarding();
  const navigate = useNavigate();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!state) return;
    if (firedRef.current) return;
    if (!state.should_show_signature_nudge) return;

    firedRef.current = true;
    toast(
      'Next up: your email signature',
      {
        description:
          'Personalize the footer that goes on every outbound email — takes 30 seconds.',
        duration: 12000,
        action: {
          label: 'Set up signature',
          onClick: () => {
            markSignatureNudgeShown();
            navigate('/settings/signature');
          },
        },
        onDismiss: () => { markSignatureNudgeShown(); },
        onAutoClose: () => { markSignatureNudgeShown(); },
      },
    );
  }, [state, markSignatureNudgeShown, navigate]);

  return null;
}
